import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, KeepAlive as _KeepAlive, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "pb-6 h-full" }
const _hoisted_2 = { class: "mb-6 w-full scrollbar-thin scrollbar-track-transparent scrollbar-thumb-transparent" }
const _hoisted_3 = { class: "whitespace-nowrap flex gap-10 text-base leading-[36px] text-wrh-gray-dark" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "w-full bg-white rounded-xl p-4 lg:p-16 shadow-modal min-h-[calc(100vh-305px)]" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h3", { class: "text-black text-18r pb-2" }, " For security reasons, we recommend that you change your password. ", -1)
const _hoisted_7 = [
  _hoisted_6
]

import { computed, onMounted, ref } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { User } from 'firebase/auth';
import {
  MyAccountTab, Response, MyAccountTabList, Routes,
} from '@/constants';
import { useAuth, checkStringEquality } from '@/util/funcs';
import store from '@/store';
import { Homebuyer, ReqHomesDocument } from '@/models';
import ContactInfo from '@/views/my-account/components/ContactInfo.vue';
import ChangePassword from './components/ChangePassword.vue';
import AddAdditionalUser from './components/AddAdditionalUser.vue';
import TransferWarranty from './components/TransferWarranty.vue';
import Alert from '@/components/Alert.vue';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const router = useRouter();
const route = useRoute();

const currentTab = ref('');
currentTab.value = (route.query.tab || '') as string;
const modalActive = ref('');
const user = ref<User | null>(null);
const isEmailVerified = ref(true);

const buyer = computed(() => store.getters.homebuyer as Homebuyer);
const selectedHome = computed(() => store.getters.selectedHome as ReqHomesDocument);

const selectedTab = () => {
  switch (currentTab.value.toLowerCase()) {
    case MyAccountTab.TRANSFER_WARRANTY:
      return TransferWarranty;

    case MyAccountTab.ADD_ADDITIONAL_USER:
      return AddAdditionalUser;

    case MyAccountTab.CHANGE_PASSWORD:
      return ChangePassword;

    default:
      currentTab.value = isEmailVerified.value
        ? MyAccountTab.UPDATE_CONTACT_INFO
        : MyAccountTab.CHANGE_PASSWORD;
      return isEmailVerified.value ? ContactInfo : ChangePassword;
  }
};

onMounted(async () => {
  const auth = await useAuth();
  user.value = auth.user.value;
  isEmailVerified.value = auth.isEmailVerified.value;
});

const updateSelectedTab = (value: string) => {
  if (isEmailVerified.value) {
    if (
      checkStringEquality(value, MyAccountTab.ADD_ADDITIONAL_USER)
      && !Object.keys(selectedHome.value).length
    ) {
      router.push({ name: Routes.HOMES });
    } else {
      currentTab.value = value;
      router.push({
        query: {
          tab: value.toLowerCase(),
        },
      });
    }
  }
};

const showModal = (modalType: Response) => {
  modalActive.value = modalType;
};

const component = computed(() => selectedTab());


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("ul", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(MyAccountTabList), (tab, idx) => {
            return (_openBlock(), _createElementBlock("li", {
              key: idx,
              class: _normalizeClass([
            't-16r leading-10',
            _unref(checkStringEquality)(currentTab.value, tab.key) ? 'text-black font-medium border-wrh-blue-light border-b-3' : 'border-b-3 border-transparent',
            !isEmailVerified.value ? 'cursor-not-allowed' : 'cursor-pointer',
            tab.key,
          ]),
              onClick: ($event: any) => (updateSelectedTab(tab.key))
            }, _toDisplayString(tab.name), 11, _hoisted_4))
          }), 128))
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", {
          class: _normalizeClass({ hidden: !!isEmailVerified.value })
        }, _hoisted_7, 2),
        (_openBlock(), _createBlock(_KeepAlive, null, [
          (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(component)), {
            homeBuyer: _unref(buyer),
            onShowAlert: showModal
          }, null, 8, ["homeBuyer"]))
        ], 1024))
      ])
    ]),
    (modalActive.value)
      ? (_openBlock(), _createBlock(Alert, {
          key: 0,
          alertType: modalActive.value,
          onCloseAlert: _cache[0] || (_cache[0] = ($event: any) => (modalActive.value = ''))
        }, null, 8, ["alertType"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})